import listAPI from "../api/api";
import CreateDataContext from "./CreateDataContext";

const GalleryReducer = (state, action) => {
    switch (action.type) {
        case "get_all_gallery":
            return { ...state, GalleryList: action.payload };
        case "get_all_gallery_status":
            return { ...state, GalleryListStatus: action.payload };
        case "clear_get_all_gallery_status":
            return { ...state, GalleryListStatus: "" };

        case "create_gallery":
            return { ...state, CreateGallery: action.payload };
        case "create_gallery_status":
            return { ...state, CreateGalleryStatus: action.payload };
        case "clear_create_gallery_status":
            return { ...state, CreateGalleryStatus: "" };

        case "delete_gallery_status":
            return { ...state, DeleteGalleryStatus: action.payload };
        case "clear_delete_gallery_status":
            return { ...state, DeleteGalleryStatus: "" };

        case "update_gallery":
            return { ...state, UpdateGallery: action.payload };
        case "update_gallery_status":
            return { ...state, UpdateGalleryStatus: action.payload };
        case "clear_update_gallery_status":
            return { ...state, UpdateGalleryStatus: "" };

        default:
            return state;
    }
};

const config = {
    headers: {
        "Content-Type": "application/json",
    },
};

const getAllGallery = (dispatch) => async () => {
    try {
        const response = await listAPI.get('gallery/getAllGallery');
        dispatch({ type: "get_all_gallery", payload: response.data });
        dispatch({ type: "get_all_gallery_status", payload: response.status, });

    } catch (e) {
        console.log("errrr", e);
        dispatch({ type: "get_all_gallery_status", payload: 400 });
    }
};

const clearGetAllGalleryStatus = (dispatch) => () => {
    dispatch({ type: "clear_get_all_gallery_status" });
};


/** Create Gallery **/
const createGallery = dispatch => async ({ bannerImage, name, image }) => {
    try {
        const form = new FormData();

        form.append('name', name);
        // form.append('images', image);
        form.append('images', bannerImage);
        image.forEach((file) => {
            // console.log("Appending file:", file.name);
            form.append("images", file)
        })

        const response = await listAPI.post("gallery/add", form, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        dispatch({ type: "create_gallery", payload: response.data });
        dispatch({ type: "create_gallery_status", payload: response.status });
    } catch (err) {
        console.log(err.message);
        dispatch({ type: "create_gallery_status", payload: 400 })

    }
}

const clearCreateGalleryStatus = dispatch => () => {
    dispatch({ type: "clear_create_gallery_status" });
};

/** Update Gallery **/
const updateGallery = dispatch => async ({ galleryId, name, mainImage, image, imageIndex }) => {
    try {
        const form = new FormData();

        form.append('name', name);
        if (mainImage instanceof File) {
            form.append('mainImage', mainImage);
        }
        if (image instanceof File) {
            form.append('images', image);
            form.append('imageIndex', imageIndex);
        }

        const response = await listAPI.put("/gallery/updateGalleryById/" + galleryId, form, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        dispatch({ type: "update_gallery", payload: response.data });
        dispatch({ type: "update_gallery_status", payload: response.status });
    } catch (err) {
        console.log(err.message);
        dispatch({ type: "update_gallery_status", payload: err.response?.status || 400 })
    }
}


const clearUpdateGalleryStatus = dispatch => () => {
    dispatch({ type: "clear_update_gallery_status" });
};


/** Delete gallery **/
const deleteGallery = (dispatch) => async (imgId) => {
    try {
        const response = await listAPI.delete("/gallery/deleteGalleryById/" + imgId);
        dispatch({ type: "delete_gallery_status", payload: response.status });
        console.log("test", response)
    } catch (e) {
        console.log(e);
        dispatch({ type: "delete_gallery_status", payload: 400 });
    }
};
const clearDeleteGalleryStatus = (dispatch) => () => {
    dispatch({ type: "clear_delete_gallery_status" });
};


export const { Provider, Context } = CreateDataContext(
    GalleryReducer,
    {
        getAllGallery, clearGetAllGalleryStatus,
        createGallery, clearCreateGalleryStatus,
        deleteGallery, clearDeleteGalleryStatus,
        updateGallery, clearUpdateGalleryStatus
    },
    {
        GalleryList: [],
        GalleryListStatus: "",
        CreateGallery: [],
        CreateGalleryStatus: "",
        DeleteGalleryStatus: "",
        UpdateGallery: [],
        UpdateGalleryStatus: ""
    }
);
